import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Camera, Loader2, Check } from 'lucide-react';
import { AdminPageHeader, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

export default function AdminPhotoCheck() {
  const { authFetch } = useAdmin();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(new Set());

  const load = async () => {
    setLoading(true);
    const r = await authFetch(`${API}/admin/photo-check`);
    setData(await r.json());
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const toggle = (id) => {
    const next = new Set(selected);
    next.has(id) ? next.delete(id) : next.add(id);
    setSelected(next);
  };

  const verifySelected = async () => {
    if (selected.size === 0) return;
    const r = await authFetch(`${API}/admin/photo-check/verify`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ article_ids: Array.from(selected), verified: true }),
    });
    if (r.ok) { toast.success(`Verificirano: ${(await r.json()).modified}`); setSelected(new Set()); load(); }
  };

  return (
    <div data-testid="admin-photo-check">
      <AdminPageHeader icon={Camera} title="Provjera fotografija" subtitle={`Članci bez verificirane slike: ${data?.total ?? '…'}`}>
        <button onClick={verifySelected} disabled={selected.size === 0} data-testid="photo-verify-btn"
                className="inline-flex items-center gap-1 px-3 py-2 rounded bg-red-600 hover:bg-red-700 disabled:opacity-40 text-white text-sm font-bold">
          <Check size={14}/> Verificiraj odabrane ({selected.size})
        </button>
      </AdminPageHeader>
      <div className="px-4 md:px-6 pb-6">
        {loading || !data ? <Loader2 className="animate-spin"/> : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {(data.items || []).map(a => (
              <label key={a.id} data-testid={`photo-card-${a.id}`}
                     className={`border rounded overflow-hidden cursor-pointer ${selected.has(a.id) ? 'border-red-500' : 'border-zinc-800'}`}>
                <div className="h-28 bg-zinc-900 relative">
                  {a.featured_image
                    ? <img src={a.featured_image} alt="" className="w-full h-full object-cover"/>
                    : <div className="flex items-center justify-center h-full text-zinc-600 text-xs">Bez slike</div>}
                  <input type="checkbox" checked={selected.has(a.id)} onChange={() => toggle(a.id)}
                         className="absolute top-2 left-2" data-testid={`photo-check-${a.id}`}/>
                </div>
                <div className="p-2 text-xs line-clamp-2">{a.title}</div>
              </label>
            ))}
            {(data.items || []).length === 0 && <p className="col-span-full text-center text-zinc-500 py-8">Sve slike verificirane.</p>}
          </div>
        )}
      </div>
    </div>
  );
}
